<div class="modal-header">
  <div class="title">
      <h2 class="modal-title-prefix"><span translate="UPDATEKOMITENTNBS.SINGULAR"></span></h2>

      <h1 class="modal-title" *ngIf = "showTable">
        <span><span translate="UPDATEKOMITENTNBS.AZURIRANIPODACI.SINGULAR"></span></span>
    </h1>
  </div>

  <!-- <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span> -->
</div>
<div class="modal-body">
  <p *ngIf = "showQuestion">Ažuriranje može potrajati nekoliko minuta, da li želite da ažurirate podatke o tekućim računima sa servisa NBS?</p>
  
  <div *ngIf = "showTable">
    <yt-fw-default-table
    [Config]="Config"
    [Items]="items"
    [TableColumns]="TableColumns"
    [ShowLoader]="MainItemsLoading">
    </yt-fw-default-table>
  </div> 
<p *ngIf="showMessage">Nema novih ažuriranih podataka.</p>
</div>
<div class="modal-footer">
  <div *ngIf="showQuestionButtons">
    <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()" [disabled]="isDisabled" style="margin-right: 10px;"><i>Potvrdi</i><span *ngIf="loadingInProgress" class="loader"><span class="fa fa-spinner fa-spin"></span></span></button>
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()" [disabled]="isDisabled"><span>Odustani</span></button>
  </div>
  <div *ngIf="showCloseButton">
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Zatvori</span></button>
  </div>
</div>
